import $ from 'jquery';
import BaseView from '../../core/baseView';
import UploadManager from './UploadManager';
import { get as t } from '../../../home24/core/translation';
import { bytesToSize } from '../../../home24-shared/core/Utils';
import * as lightbox from '../../../home24/helpers/lightbox';

export default BaseView.extend({

    /**
     * File remove handler
     * @param event
     */
    onFileRemoveClicked: function (event) {
        event.preventDefault();

        var $cT = $(event.currentTarget);
        var uploadManager = new UploadManager();

        uploadManager.remove($cT.data('uid'));

        $cT.closest('li').remove();

        this.postFileRemove();
    },

    startUpload: function (event) {

        var uploadManager = new UploadManager();

        this.prepareUploadManager(uploadManager, event);

        this.messageBox.clear();

        if (uploadManager.isValid()) {
            /*
             Proceed with upload process
             */
            uploadManager
                .setOnSuccess($.proxy(this.onUploadSuccess, this))
                .setOnFailure($.proxy(this.onUploadFailure, this));

            lightbox.close();

            this.showPreloader();

            uploadManager.execute();

            this.insertTemplate(uploadManager.getUid(), uploadManager.getParsedFilename(), this.getUploadContainer());
        } else {
            /*
             Handle errors
             */
            var errors = uploadManager.getErrors();

            for (var i = 0; i < errors.length; i++) {
                this.messageBox.addError(errors[i].message);
            }
        }

        this.messageBox.render();
    },

    showPreloader: function () {
        $('#preloader').show();
    },

    hidePreloader: function () {
        $('#preloader').hide();
    },

    /**
     * Method inserts new file container and populates it with dummy data
     * @param {string} uid
     * @param {string} sName
     * @param {Object} $container
     */
    insertTemplate: function (uid, sName, $container) {
        var $cloned = this.$uploadTemplate.clone();

        $cloned.find('.fttc2-name').html(sName);
        $cloned.attr('id', this.formatRowId(uid));
        $container.find('.fttc2-uploaded-files').first().append($cloned);

        this.postInsertTemplate($cloned);
    },

    /**
     * On upload success handler. It updates previously generated view stub
     * @param {string} uid
     * @param {object} json
     */
    onUploadSuccess: function (uid, json) {
        var $container = this.$('#' + this.formatRowId(uid));

        $container.find('.fttc2-close').data('uid', json.uid);

        /** @namespace json.thumbPath */
        if (json.thumbPath) {
            $container.find('.fttc2-img-holder img').attr('src', json.thumbPath);
        }

        /** @namespace json.fileSize */
        if (json.fileSize) {
            $container.find('.fttc2-size').html('(' + bytesToSize(json.fileSize) + ')');
        }

        this.hidePreloader();
        this.postUploadSuccess();
    },

    /**
     * Method if fired on upload failure
     * @param {String} uid upload identifier
     * @param {Object} json JSON object returned by backend
     * @return void
     */
    onUploadFailure: function (uid, json) {
        this.$('#' + this.formatRowId(uid)).remove();

        this.messageBox.clear();

        /** @namespace json.errorMessage */
        if (json.errorMessage) {
            this.messageBox.addError(json.errorMessage);
        } else {
            this.messageBox.addError(t('fileUpload.unknownError.message'));
        }

        this.messageBox.render();
        this.hidePreloader();
        this.postUploadFailure();
    },

    formatRowId: function (uid) {
        return 'row_' + uid;
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/BaseUploadView.js
 **/